export const STATUS_STYLES = {
  active: "bg-emerald-500/12 text-emerald-700 dark:text-emerald-400 border-emerald-500/25",
  paused: "bg-amber-500/12 text-amber-700 dark:text-amber-400 border-amber-500/25",
  replied: "bg-blue-500/12 text-blue-700 dark:text-blue-400 border-blue-500/25",
  completed: "bg-muted text-muted-foreground border-border",
  failed: "bg-rose-500/12 text-rose-700 dark:text-rose-400 border-rose-500/25",
  stopped: "bg-muted text-muted-foreground border-border",
  awaiting: "bg-amber-500/12 text-amber-700 dark:text-amber-400 border-amber-500/25",
  sent: "bg-emerald-500/12 text-emerald-700 dark:text-emerald-400 border-emerald-500/25",
  received: "bg-blue-500/12 text-blue-700 dark:text-blue-400 border-blue-500/25",
};

const DOT = { active: "bg-emerald-500", paused: "bg-amber-500", replied: "bg-blue-500", failed: "bg-rose-500", awaiting: "bg-amber-500 animate-pulse", sent: "bg-emerald-500", received: "bg-blue-500" };

export function StatusPill({ status, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.08em] px-2 py-0.5 rounded-full border ${STATUS_STYLES[status] || STATUS_STYLES.completed}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${DOT[status] || "bg-muted-foreground/50"}`} />{status}
    </span>
  );
}

export function fmtDelay(days) {
  const d = Number(days || 0);
  if (d === 0) return "Immediately";
  if (d < 1 / 24) return `+${Math.max(1, Math.round(d * 24 * 60))} min`;
  if (d < 1) return `+${Math.round(d * 24)} h`;
  return `+${d} day${d === 1 ? "" : "s"}`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = d.getTime() - Date.now();
  const abs = Math.abs(diff);
  const unit = abs < 3600e3 ? [Math.round(abs / 60e3), "m"] : abs < 86400e3 ? [Math.round(abs / 3600e3), "h"] : [Math.round(abs / 86400e3), "d"];
  return diff > 0 ? `in ${unit[0]}${unit[1]}` : `${unit[0]}${unit[1]} ago`;
}
